import * as React from 'react';
import * as styles from './RequestDemandBlock.css';
import { Button } from '@cian/ui-kit/button';
import { InlineText1, InlineText2 } from '@cian/ui-kit/typography';

export interface IRequestDemandBlockProps {
  title: string;
  text: string;
  buttonText: string;
  buttonAction: () => void;
  image: string;
}

export const RequestDemandBlock: React.FC<IRequestDemandBlockProps> = ({
  title,
  text,
  buttonText,
  buttonAction,
  image,
}) => (
  <div className={styles['root']}>
    <div className={styles['content']}>
      <div className={styles['title']}>
        <InlineText1 fontWeight="bold">{title}</InlineText1>
      </div>
      <div className={styles['text']}>
        <InlineText2 color="gray60_100">{text}</InlineText2>
      </div>
      <div className={styles['action']}>
        <Button theme="fill_secondary" size="XS" onClick={buttonAction}>
          {buttonText}
        </Button>
      </div>
    </div>
    <div className={styles['image-wrapper']}>
      <img src={image} />
    </div>
  </div>
);

RequestDemandBlock.displayName = 'RequestDemandBlock';
